import { Switch } from "@mui/material";
import { useStyles } from "./MainSwitch.styles";
import { IMainSwitch } from "./MainSwitchInterfaces";

const MainSwitch = ({ onChange, checked, defaultChecked, disabled }: IMainSwitch) => {
    const classes = useStyles();
    return (
        <Switch
            onClick={(e) => e.stopPropagation()}
            defaultChecked={defaultChecked}
            className={classes.switch}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            inputProps={{ "aria-label": "controlled" }}
        />
    );
};

export default MainSwitch;
